

import React from "react";

interface Option {
  value: string | number;
  label: string;
}

const RadioButton: React.FC<{
  title: string;
  name: string;
  options: Option[];
  selectedValue: string;
  onChange: (value: string) => void;
  display?: string;
}> = ({
  title,
  name,
  options,
  selectedValue,
  onChange,
  display = "flex-row gap-4",
}) => {
  return (
    <div className="flex flex-col gap-3 text-xs">
      <p className="text-xs font-semibold">{title}</p>

      <div className={`flex ${display}`}>
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center cursor-pointer"
          >
            <div
              className={`relative w-4 h-4 rounded-full border ${selectedValue === option.value ? "border-blue-700" : "border-[#CBD5E1]"} flex items-center justify-center`}
            >
              {selectedValue === option.value && (
                <div className="w-1.5 h-1.5 bg-blue-700 rounded-full" />
              )}
            </div>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={() => onChange(String(option.value))}
              className="hidden"
            />
            <span className="ml-2 text-xs">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioButton;
